import { useRef } from "react"

import Paper from "@material-ui/core/Paper"

import { useTableScroll } from "common/hooks"

import Header from "components/partials/Header"

const Admin = props => {
  const footer = useRef(null)
  useTableScroll(footer)

  return (
    <>
      <Header />
      <Paper>{props.children}</Paper>
    </>
  )
}

export default Admin
